import { render, staticRenderFns } from "./JcdcRadioGroup.vue?vue&type=template&id=6da4b30e"
import script from "./JcdcRadioGroup.vue?vue&type=script&lang=ts"
export * from "./JcdcRadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./JcdcRadioGroup.vue?vue&type=style&index=0&id=6da4b30e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports